export default __webpack_public_path__ + "static/media/shoot_gun.f17f99df.gif";